import styled from "@emotion/styled";

export const IconInputStyles = styled("div")`
  display: flex;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  background-color: #f6f6fa;

  .icon-input {
    &__icon-wrap {
      margin: 10px 0 0 8px;
    }

    &__clear {
      cursor: pointer;
      margin: 8px 5px 0 0;
    }
  }

  .input {
    border-radius: 4px;
    border: 0;
    color: #293359;
    background-color: #f6f6fa;
    outline: none;
    width: 100%;
  }
`;
